<template>
  <div class="order">
    <search
      :statusList="statusList"
      settlementStatus="0"
      @handleSearch="handleSearch"
    />
    <div class="table-container">
      <div class="table-btn">
        <!-- :loading="exportLoading" -->
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport(2)"
          >导出索赔结算单</el-button
        >
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport(3)"
          >导出索赔明细（索赔单）</el-button
        >
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport(4)"
          >导出索赔明细（故障件）</el-button
        >
      </div>
      <!-- v-loading="loading" -->
      <el-table
        :data="tableData"
        highlight-current-row
        border
        stripe
        @filter-change="filterChange"
      >
        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="settlementId"
          label="索赔结算单号"
          :min-width="$getColumnWidth('settlementId', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerCountry"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          align="center"
          column-key="customerCountry"
          :filters="this.countryList"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            <p>{{ getCountry(scope.row.customerCountry) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerCompanyName"
          label="公司"
          :min-width="$getColumnWidth('customerCompanyName', tableData)"
        >
        </el-table-column>
        <el-table-column
          prop="claimCount"
          label="结算索赔单数"
          :min-width="$getColumnWidth('claimCount', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="totalCostOfWork"
          label="工时总费用"
          :min-width="$getColumnWidth('totalCostOfWork', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="materialTotalCost"
          label="材料总费用"
          :min-width="$getColumnWidth('materialTotalCost', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="freight"
          label="运费总费用"
          :min-width="$getColumnWidth('freight', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="tariff"
          label="关税总费用"
          :min-width="$getColumnWidth('tariff', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="otherTotalCost"
          label="其他总费用"
          :min-width="$getColumnWidth('otherTotalCost', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="claimTotalCost"
          label="一次索赔结算总费用"
          :min-width="$getColumnWidth('claimTotalCost', tableData)"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="settlementTime"
          label="结算日期"
          :min-width="$getColumnWidth('settlementTime', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="year"
          label="结算年份"
          :min-width="$getColumnWidth('year', tableData)"
          align="center"
        >
          <template slot-scope="scope"> {{ scope.row.year }}年 </template>
        </el-table-column>
        <el-table-column
          prop="settlementCycle"
          label="结算周期"
          min-width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ `${scope.row.startTime} - ${scope.row.endTime}` }}
          </template>
        </el-table-column>
        <el-table-column
          prop="currency"
          label="结算币种"
          :min-width="$getColumnWidth('currency', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency === 0 ? "CNY" : "USD" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="settlementStatus"
          label="状态"
          :min-width="$getColumnWidth('settlementStatus', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.settlementStatus == 0 ? "待结算" : "已结算" }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.settlementStatus === 0"
              size="mini"
              type="text"
              @click="handleSettlement(scope.row, scope.$index)"
              >结算</el-button
            >
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  settlementList,
  settlement,
  settlementExport,
  climantExport
} from "@/api/seek";
import { getSession } from "@/util/localStor";
import search from "@/components/settlementSearch";
import { getNations } from "@/util/getNation";
import { getDownloadFiles } from "@/util/downFile";

export default {
  components: {
    search
  },
  data() {
    return {
      statusList: [
        { label: "全部", value: "" },
        { label: "待结算", value: "0" },
        { label: "已结算", value: "1" }
      ],
      searchInfo: {
        settlementStatus: "0"
      },
      // loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      // exportLoading: false,
      countryList: [],
      searchData: {}
    };
  },
  async mounted() {
    Object.values(getSession("nationList")).map(item => {
      if (item.id != 0) {
        this.countryList.push({ text: item.name, value: item.id });
      }
    });
    this.getList();
  },
  methods: {
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      this.searchData = JSON.parse(JSON.stringify(data));
      let obj = data;
      this.searchInfo.settlementId = obj.settlementId;
      this.searchInfo.settlementStatus = obj.settlementStatus;
      this.searchInfo.customerAccountNum = obj.customerAccountNum;
      this.searchInfo.customerName = obj.customerName;
      this.searchInfo.customerCountry =
        obj.customerCountry && obj.customerCountry != "0"
          ? [obj.customerCountry]
          : [];
      this.searchInfo.currency = obj.currency;
      this.page = 1;
      this.pageSize = 10;
      if ((data.settlementTime || []).length === 2) {
        this.searchInfo.settlementTimeStart =
          data.settlementTime[0] + " 00:00:00";
        this.searchInfo.settlementTimeEnd =
          data.settlementTime[1] + " 23:59:59";
      } else {
        this.searchInfo.settlementTimeStart = "";
        this.searchInfo.settlementTimeEnd = "";
      }
      this.getList();
    },
    // 查看明细
    toDetail(data) {
      this.$router.push({
        path: "/claimant/claimSettlementDetailList",
        query: { settlementId: data.settlementId }
      });
    },
    // 结算
    handleSettlement(data) {
      this.$confirm(`确认结算 ${data.settlementId} 并下发至客户端？`, "结算", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(async () => {
          const res = await settlement({
            data: { settlementId: data.settlementId }
          });
          if (res.status == "0") {
            this.$DonMessage.success("结算成功");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        })
        .catch(() => {});
    },
    // 导出
    async handleExport(type) {
      // this.exportLoading = true;
      let query = {
        data: {
          ...this.searchInfo,
          exportType: type
        }
      };
      var res = {};
      if (type === 2) {
        res = await settlementExport(query);
      } else {
        res = await climantExport(query);
      }
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！");
      }
      // this.exportLoading = false;
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 获取列表
    async getList() {
      // this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await settlementList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.loading = false;
      }
      // this.loading = false;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filterChange(value) {
      // 国家过滤
      if (value.customerCountry) {
        if (value.customerCountry.length === 0) {
          this.searchInfo.customerCountry =
            this.searchData.customerCountry || [];
        } else {
          this.searchInfo.customerCountry = value.customerCountry;
        }
      }
      this.getList();
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.responsibilityPartListTip {
  display: flex;
  text-align: center;
  padding: 18px 20px;
  .item {
    width: 120px;
  }
  .item2 {
    width: 180px;
  }
}
</style>
